<div class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" (click)="closed.emit()">
  <div
    class="bg-base-100 rounded-lg shadow-xl w-full max-w-3xl max-h-[90vh] flex flex-col"
    (click)="$event.stopPropagation()"
  >
    <!-- Kopfzeile: Titel, gewählter Typ und (falls erlaubt) der Weg zurück zur Kachelwahl -->
    <div class="flex items-start justify-between gap-3 p-4 border-b border-base-300">
      <div class="min-w-0">
        <div class="font-semibold">
          {{ state.mode() === "edit" ? "Versandziel bearbeiten" : "Versandziel anlegen" }}
        </div>
        @if (state.page() === "positions") {
          <div class="text-sm opacity-70 mt-0.5">
            {{ typeLabel() }}
            @if (state.canChangeType()) {
              <button type="button" class="bm-btn bm-btn-ghost bm-btn-xs ml-1" (click)="state.page.set('type')">
                <fa-icon [icon]="iconEdit" class="mr-1" />Typ ändern
              </button>
            }
          </div>
        } @else {
          <div class="text-sm opacity-70 mt-0.5">Wohin geht das Material?</div>
        }
      </div>
      <button type="button" class="bm-btn bm-btn-ghost bm-btn-sm" (click)="closed.emit()">Schließen</button>
    </div>

    <div class="flex-1 overflow-y-auto p-4 flex flex-col gap-3">
      @if (state.readOnly()) {
        <div class="bm-alert bm-alert-warning bm-alert-soft text-sm">
          <fa-icon [icon]="iconInfo" />
          <span>
            Für dieses Versandziel ist bereits versandt worden — es ist damit eingefroren. Für ein abweichendes
            Ziel bitte ein neues Versandziel anlegen. Die Versandzeitpunkte bleiben in der Matrix änderbar.
          </span>
        </div>
      } @else if (state.mode() === "edit" && !state.canChangeType()) {
        <div class="bm-alert bm-alert-info bm-alert-soft text-sm">
          <fa-icon [icon]="iconInfo" />
          <span>
            Für dieses Versandziel sind bereits Mengen vorbereitet — der Versandtyp lässt sich nicht mehr
            wechseln.
          </span>
        </div>
      }

      @if (state.page() === "type") {
        <hawk-shipping-type-select-page />
      } @else {
        <hawk-shipping-positions-page />
      }

      @if (state.errorMessage(); as error) {
        <div class="bm-alert bm-alert-error bm-alert-soft text-sm">{{ error }}</div>
      }
    </div>

    <!-- Fußzeile: links das Entfernen, rechts die Aktionen -->
    <div class="flex items-center justify-between gap-2 p-4 border-t border-base-300">
      <div class="shrink-0">
        @if (state.mode() === "edit" && !state.readOnly()) {
          <span [title]="canDelete() ? 'Versandziel entfernen' : 'Nicht löschbar — an diesem Ziel hängen bereits Sendungen'">
            <button
              type="button"
              class="bm-btn bm-btn-error bm-btn-sm"
              [disabled]="!canDelete() || state.saving()"
              (click)="onDelete()"
            >
              Versandziel löschen
            </button>
          </span>
        }
      </div>
      <div class="flex gap-2 shrink-0">
        <button type="button" class="bm-btn bm-btn-ghost bm-btn-sm" (click)="closed.emit()">Abbrechen</button>
        @if (!state.readOnly() && state.page() === "positions") {
          <button
            type="button"
            class="bm-btn bm-btn-primary bm-btn-sm"
            [disabled]="!state.canSave() || state.saving()"
            (click)="onSave()"
          >
            {{ state.saving() ? "Speichere …" : state.mode() === "edit" ? "Speichern" : "Anlegen" }}
          </button>
        }
      </div>
    </div>
  </div>
</div>

<!-- PickPoint-Kartenauswahl: bewusst außerhalb des Dialog-Rahmens, damit sie ihn vollflächig überdeckt -->
@if (state.showMapPicker() && state.canOpenMap()) {
  <hawk-pickpoint-map-picker
    [centerLat]="state.ticketLat()!"
    [centerLng]="state.ticketLng()!"
    [referenceDate]="state.referenceDate()"
    [initialStationId]="state.selectedStation()?.id"
    (stationSelected)="state.setStation($event)"
    (closed)="state.showMapPicker.set(false)"
  />
}
